export class AdjustmentReasonMiniEntity {
  id?: number
  name?: string | null
}
